// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"63478608","281":"c8f899b5"}[chunkId] + ".chunk.js";
};